import styled from "styled-components";
import OfferingOfferDetailsTable from "./offering-offer-details-table";
import {
  PricelistOffersGetByIdOffers,
  PricelistOffersGetByIdPayload,
} from "../../../../services/orders/pricelist-offers-get-by-id/types";
import OfferingOfferPricelistTable from "./offering-offer-pricelist-table";
import OfferingSubcontractorsOffers from "./offering-subcontractors-offers";
import { useEffect } from "react";
interface OfferingDetailsSectionProps {
  pricelistOffer: PricelistOffersGetByIdOffers;
  additionalServicesQuantity: number;
  isDeletable: boolean;
}
const OfferingDetailsSection = ({
  pricelistOffer,
  additionalServicesQuantity,
  isDeletable,
}: OfferingDetailsSectionProps) => {
  return (
    <>
      <OfferingDetailsSectionContainer>
        <SectionsDivider />
        <OfferingOfferDetailsTable
          pricelistOffer={pricelistOffer}
          isDeletable={isDeletable}
        />

        <OfferingOfferPricelistTable
          subcontractorOffers={pricelistOffer.oferty_podwykonawcy}
        />
        {pricelistOffer.oferty_podwykonawcy.map((item) => (
          <OfferingSubcontractorsOffers
            key={item.id_oferta_podwykonawcy}
            additionalServicesQuantity={additionalServicesQuantity}
            subcontractorOffer={item}
            isDeletable={isDeletable}
          />
        ))}
      </OfferingDetailsSectionContainer>
    </>
  );
};

export default OfferingDetailsSection;

const OfferingDetailsSectionContainer = styled.section`
  width: 100%;

  margin: 12px 0;
  display: flex;
  flex-direction: column;
`;
const SectionsDivider = styled.hr`
  width: 100%;
  height: 1px;
  margin-top: 70px;
  background-color: black;
`;
